import React, { memo } from "react";
import { Tooltip, IconButton, Icon } from "@chakra-ui/react";
import { FaCalendarPlus, FaRegCalendarPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

const MultipliedPostDetailsButton = ({ postId, masterId, buttonProps, onClick }) => {
  const { t } = useTranslation(["planner"]);
  const icon = postId === masterId ? FaCalendarPlus : FaRegCalendarPlus;

  const handleClick = useCallback((event) => {
    event.stopPropagation();

    onClick?.({
      postId,
      masterId,
    });
  }, [postId, masterId, onClick]);

  return (
    <>
      <Tooltip
        label={t("post_multiply.multiplied_post.show_copies")}
        hasArrow
        placement="top"
      >
        <IconButton
          icon={<Icon as={icon} />}
          variant="ghost"
          height="1em"
          width="1em"
          minWidth="1em"
          lineHeight="1"
          fontSize="14px"
          onClick={handleClick}
          {...buttonProps}
        />
      </Tooltip>
    </>
  );
};

export default memo(MultipliedPostDetailsButton);
